import React from "react";
import { Route, Routes } from "react-router-dom";
import Countrys from "../layout/country/Countrys";
import AddAndEditCountry from "../layout/country/AddAndEditCountry";

const CountryPage = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Countrys />} />
        <Route path="/add" element={<AddAndEditCountry />} />
        <Route path="/update/:id" element={<AddAndEditCountry />} />
      </Routes>
    </>
  );
};

export default CountryPage;
